<ul class="show-notification"
    [@openClose]="isOpen ? 'open' : 'closed'"
    *ngIf="type === 'notification';then searchCategories else notificationBox">
    <li class=" d-flex align-items-center justify-content-between title">
        <h6>Notifications</h6>
        <span class="badge badge-danger">New</span>
    </li>
    <li>
        <a href="javascript:void('0')">
            <div class="media">
                <img class="d-flex" alt="image">
                <div class="media-body">
                    <h5 class="notification-user">John Doe</h5>
                    <p class="notification-msg">Lorem ipsum dolor sit amet, consectetuer elit.</p>
                    <span class="notification-time">30 minutes ago</span>
                </div>
            </div>
        </a>
    </li>
    <li>
        <a href="javascript:void('0')">
            <div class="media">
                <img class="d-flex" alt="image">
                <div class="media-body">
                    <h5 class="notification-user">John Doe</h5>
                    <p class="notification-msg">Lorem ipsum dolor sit amet, consectetuer elit.</p>
                    <span class="notification-time">30 minutes ago</span>
                </div>
            </div>
        </a>
    </li>
</ul>
<ng-template #searchCategories>
    <ul class="show-notification search-categories" [@openClose]="isOpen ? 'open' : 'closed'">
        <li><a href="javascript:void('0')" (click)="onChangeCagtegoryClicked(0)">All</a></li>
        <li><a href="javascript:void('0')" (click)="onChangeCagtegoryClicked(1)">Name</a></li>
        <li><a href="javascript:void('0')" (click)="onChangeCagtegoryClicked(2)">Email</a></li>
        <li><a href="javascript:void('0')" (click)="onChangeCagtegoryClicked(3)">Account</a></li>
    </ul>
</ng-template>

<ng-template #notificationBox>
    <ul class="show-notification profile-notification" [@openClose]="isOpen ? 'open' : 'closed'">
<!--        <li>-->
<!--            <a href="javascript:void('0')">-->
<!--                <i class="fa fa-cog"></i>Settings-->
<!--            </a>-->
<!--        </li>-->
        <li>
            <a href="javascript:void('0')" [routerLink]="links.profile">
                <i class="fa fa-user"></i>Profile
            </a>
        </li>
        <li>
            <a href="javascript:void('0')" (click)="onLogoutClick()">
                <i class="fa fa-sign-out"></i>Logout
            </a>
        </li>
    </ul>
</ng-template>

